import { useState } from "react";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { Bell, Mail, MessageSquare, Calendar } from "lucide-react";

export function NotificationSettings() {
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const [notifications, setNotifications] = useState({
    email: {
      assessmentReminders: "Assessment Reminders",
      monthlyReports: "Monthly Reports",
      securityAlerts: "Security Alerts",
    },
    inApp: {
      newMessages: "New Messages",
      appointmentReminders: "Appointment Reminders",
      systemUpdates: "System Updates",
    }
  });

  const handleSave = async () => {
    setIsLoading(true);
    try {
      // Save to backend
      toast({
        title: "Settings saved",
        description: "Your notification preferences have been updated.",
      });
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to save notification settings.",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
          <Mail className="w-5 h-5" />
          Email Notifications
        </h2>
        <div className="space-y-4">
          {Object.entries(notifications.email).map(([key, label]) => (
            <div key={key} className="flex items-center justify-between">
              <div>
                <p className="font-medium">{label}</p>
              </div>
              <Switch
                checked={true}
                onCheckedChange={(checked) =>
                  setNotifications({
                    ...notifications,
                    email: { ...notifications.email, [key]: checked }
                  })
                }
              />
            </div>
          ))}
        </div>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
          <Bell className="w-5 h-5" />
          In-App Notifications
        </h2>
        <div className="space-y-4">
          {Object.entries(notifications.inApp).map(([key, label]) => (
            <div key={key} className="flex items-center justify-between">
              <div>
                <p className="font-medium">{label}</p>
              </div>
              <Switch
                checked={true}
                onCheckedChange={(checked) =>
                  setNotifications({
                    ...notifications,
                    inApp: { ...notifications.inApp, [key]: checked }
                  })
                }
              />
            </div>
          ))}
        </div>
      </div>

      <Button 
        onClick={handleSave} 
        disabled={isLoading}
        className="w-full"
      >
        Save Notification Preferences
      </Button>
    </div>
  );
} 